import OrderTrackingList from './OrderTrackingList';

export default OrderTrackingList;
